import type { IFormxRepository } from '../repositories/IFormxRepository.js';
import type { FormxSubmissionEntity, FormxValueEntity } from '../entities/FormxEntity.js';

interface Deps { formxRepository: IFormxRepository; }

export function createGetFormxSubmissionUseCase({ formxRepository }: Deps) {
  return async function getFormxSubmission(id: string): Promise<{ submission: FormxSubmissionEntity; values: FormxValueEntity[] } | null> {
    return formxRepository.getSubmissionWithValues(id);
  };
}
